var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9694 10.7771C19.0451 10.5716 19.0522 10.3475 18.9896 10.1377C18.927 9.92787 18.7979 9.74352 18.6215 9.61181C18.445 9.48001 18.2303 9.40785 18.0093 9.40599C17.7882 9.40413 17.5724 9.47268 17.3936 9.60149C17.2148 9.73011 17.0825 9.9122 17.0162 10.1209C16.9499 10.3296 16.953 10.5538 17.0251 10.7606",
    stroke: "#00B956",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0938 24.7032H25.9062L25.3494 24.1064C24.1611 22.8334 23.5001 21.157 23.5 19.4156V16.2813C23.5 14.8226 22.9205 13.4236 21.8891 12.3922C20.8576 11.3607 19.4587 10.7813 18 10.7813C16.5442 10.7824 15.1483 11.3611 14.1189 12.3905C13.0895 13.4199 12.5107 14.8158 12.5096 16.2716L12.5048 19.4225C12.5017 21.1596 11.8409 22.8311 10.6554 24.1008L10.0938 24.7032Z",
    stroke: "#00B956",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9608 24.8434C16.0367 25.3386 16.2902 25.7893 16.674 26.1113C17.0579 26.4333 17.5458 26.6045 18.0467 26.593C18.5475 26.5817 19.0271 26.3884 19.3959 26.0494C19.7647 25.7103 19.9974 25.2487 20.0508 24.7506",
    stroke: "#00B956",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotify);
export default __webpack_public_path__ + "static/media/icon-notify.6d7a842953b787234f5ce09d62ae125d.svg";
export { ForwardRef as ReactComponent };